export default {
    data () {
        return {
            translations: {
                "Basic data" : "Basisgegevens",
                "Initials" : "Voorletters",
                "Infix" : "Voorvoegsel",
                "First name" : "Voornaam",
                "Prefix" : "Tussenvoegsel",
                "Last name" : "Achternaam",
                "Date of birth" : "Geboortedatum",
                "Date of birth Format" : "DD-MM-YYYY",
                "Sex" : "Geslacht",
                "Sex-O" : "Onbekend",
                "Sex-M" : "Man",
                "Sex-m" : "Jongen",
                "Sex-V" : "Vrouw",
                "Sex-v" : "Meisje",
                "BSN" : "Burger Service Nummer",
                "Profession" : "Beroep",
                "Contact details" : "Contactgegevens",
                "phone number" : "telefoonnummer",
                "Phone mobile" : "Telefoon Mobiel",
                "Phone private" : "Telefoon thuis",
                "Phone work" : "Telefoon werk",
                "E-mail" : "E-mail",
                "Address" : "Adresgegevens",
                "Address number" : "Huisnummer",
                "Address number addition" : "Huisnummer toevoeging",
                "Street" : "Straat",
                "Zip code" : "Postcode",
                "Example Zip Code" : "1234 AB",
                "Place" : "Plaats",
                "City" : "Plaats",
                "Invoice details" : "Factuurgegevens",
                "Payment method" : "Betaalwijze",
                "Direct debit" : "Incasso",
                "On account" : "Op rekening",
                "Send method" : "Verzendwijze",
                "Post" : "Post",
                "Class" : "Klas",
                "General practitioner" : "Huisarts",
                "General practice": "Huisarts praktijk",
                "Phone 1" : "Telefoonnummer 1",
                "Phone 2" : "Telefoonnummer 2",
                "Mentor" : "Mentor",
                "Designated employee" : "Vast gezicht",
                "Child is allowed on photo" : "Kind mag op foto",
                "Child is allowed on photo on socialmedia" : "Kind mag op social media met foto",
                "Child is allowed on photo in newsletter" : "Kind mag in nieuwsbrief met foto",
                "Other information" : "Overige gegevens",
                "Involved employees" : "Betrokken medewerkers",
                "Vaccinations": "Vaccinaties",
                "School": "School",
                "Name": "Naam",
                "Number": "Nummer",
                "Emergency contact 1": "Noodnummer 1",
                "Emergency contact 2": "Noodnummer 2",
                "Emergency contact 3": "Noodnummer 3",
                "Yes": "Ja",
                "No": "Nee",
                "Unknown": "Niet bekend",
                "Particularities": "Bijzonderheden",
                "Enter numbers only" : "Alleen cijfers invoeren",
                'Country': 'Land',
                'The Netherlands': 'Nederland',
                'Belgium': 'België',
                'Germany':'Duitsland'
            }
        }
    },
    methods: {
        translate(name) {

            if (this.translations[name]) {
                return this.translations[name];
            }

            return name;
        }
    }
}
